/** Management screens and aliases. Clinical lookup APIs remain available separately. */
export const SETUP_ROUTE_PERMISSIONS: Record<string, string[]> = {
  "/setup/checklist": ["USER_MANAGEMENT"],
  "/hrms/departments": ["setup.departments.manage"],
  "/doctors/departments": ["setup.departments.manage"],
  "/hrms/cost-centers": ["accounting.coa.manage"],
  "/settings/department-cost-centers": ["accounting.coa.manage"],
  "/nursing/units": ["setup.units.manage"],
  "/rooms/settings": ["rooms.setup.manage"],
  "/patients/admission-masters": ["setup.admissions.manage"],
  "/settings/service-catalog": ["setup.services.manage"],
  "/settings/er-packages": ["er.packages.manage"],
  "/settings/session-types": ["sessions.types.manage"],
  "/billing/consultation-fees": ["setup.fees.manage"],
  "/inventory/hsn-reference": ["setup.inventory.manage"],
  "/inventory/item-code-config": ["setup.inventory.manage"],
};
